module.exports = __webpack_public_path__ + "static/media/NoirPro-Heavy.7194b3b5.eot";